import { useContextPanels } from '../../contexts/panelsContext'
import { cn } from '../../utils/cn'

const WhiteOverlay = () => {
  const { overlayVisible } = useContextPanels()
  return (
    <div
      className={cn('absolute left-0 top-0 z-0 h-screen w-screen bg-white75', {
        'animate-[simple-fade-in_0.7s_ease_forwards]': overlayVisible,
        'animate-[fade-out-hide_0.7s_ease_forwards]': !overlayVisible,
      })}
    />
  )
}

export default WhiteOverlay
